import { ProjectService } from '@app/main/resourcesAllocation/projects/project.service';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
  ActivitiesServiceProxy,
  CreateMyActivityInput,
  FormDefinitionDto,
  FormsServiceProxy,
} from '@shared/service-proxies/service-proxies';
import * as moment from '@node_modules/moment';
import { forkJoin } from 'rxjs';
import { Router } from '@angular/router';
import { DateAdapter } from '@angular/material/core';
import { CustomDateAdapter } from '@shared/helpers/CustomDateAdapter';

@Component({
  selector: 'app-activities-create-panel',
  templateUrl: './activities-create-panel.component.html',
  styleUrls: ['./activities-create-panel.component.less'],
  providers: [FormsServiceProxy, {
    provide: DateAdapter,
    useClass: CustomDateAdapter
  }],
})
export class ActivitiesCreatePanelComponent
  extends AppComponentBase
  implements OnInit
{
  @Input() activityData: any;
  @Input() cloneModal;
  @Input() isDynamicForm: boolean;
  @Input() selectedForm: FormDefinitionDto;
  @Output() onClosePanel: EventEmitter<any> = new EventEmitter<any>();
  @Output() onListReload: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCreated: EventEmitter<any> = new EventEmitter<any>();
  @Output() onOpenFormPanel: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('calendar', { static: false }) calendar;

  activityName;
  daysSelected: string[] = [];

  isSelected = (event: any) => {
    const date =
      event.getFullYear() +
      '-' +
      ('00' + (event.getMonth() + 1)).slice(-2) +
      '-' +
      ('00' + event.getDate()).slice(-2);
    return this.daysSelected.find((x) => x == date) ? 'selected' : null;
  };

  constructor(
    injector: Injector,
    private _activitiesServiceProxy: ActivitiesServiceProxy,
    private _projectService: ProjectService,
    private _formServiceProxy: FormsServiceProxy,
    private _router:Router,
    private cdr: ChangeDetectorRef
  ) {
    super(injector);
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 50);
  }

  closePanel() {
    this.onClosePanel.emit();
  }

  openFormPanel() {
    this.onOpenFormPanel.emit();
  }

  async saveNewActivity() {
    const projectId = await this._projectService.getCurrentOrDefaultProjectId();
    const params = new CreateMyActivityInput({
      name: this.activityName,
      activityDays: this.daysSelected.map((day) => moment(day)),
      projectId: projectId,
    });
    if (this.isDynamicForm) {
      const apiCalls = [];
      this.daysSelected.map((day) => {
        const body = {
          createdBy: this.appSession.user.userName,
          activityName: this.activityName,
          activityDate: moment(day),
        };
        apiCalls.push(
          this._formServiceProxy.saveFormData(this.selectedForm.id, body)
        );
      });
      forkJoin(apiCalls).subscribe((res) => {
        this.onCreated.emit();

        this.onListReload.emit();
        this.calendar.updateTodaysDate();
        this.closePanel();
        this._formServiceProxy
        .getFormDefinitionById(this.selectedForm.id)
        .subscribe((y) => {
            this._router.navigate([`app/main/resourcesAllocation/activities/custom-complete-forms/edit/${res[0]['id']}/${this.selectedForm.id}`]);
        //   abp.event.trigger(
        //     'app.evt.openDynamicForm',
        //     this.activityName,
        //     moment(this.daysSelected[0]),
        //     y,
        //     res[0]
        //   );
          this.notify.success(this.l('ActivityHasBeenCreated'));
        });
      });
    } else {
      this._activitiesServiceProxy
        .createMyActivity(params)
        .subscribe((created) => {
          this.onCreated.emit();

          this.onListReload.emit();
          this.calendar.updateTodaysDate();

          this.closePanel();

          if (created.activityDays && created.activityDays.length) {
            // abp.event.trigger(
            //   'app.evt.openAssignPanel',
            //   created.activityDays[0]
            // );
            this._router.navigate(['app/main/resourcesAllocation/activities/complete-forms/edit/0/'+ created.activityDays[0].activityDayId])

          }

          this.notify.success(this.l('ActivityHasBeenCreated'));
        });
    }
  }

  select(event: any, calendar: any): void {
    const date =
      event.getFullYear() +
      '-' +
      ('00' + (event.getMonth() + 1)).slice(-2) +
      '-' +
      ('00' + event.getDate()).slice(-2);
    const index = this.daysSelected.findIndex((x) => x == date);
    if (index < 0) this.daysSelected.push(date);
    else this.daysSelected.splice(index, 1);

    calendar.updateTodaysDate();
  }
}
